import { render } from "./CreatePublication.vue.js?vue&type=template&id=614e7a97&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=template&id=614e7a97&scoped=true"
import script from "./CreatePublication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=script&lang=js"
export * from "./CreatePublication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=script&lang=js"

import "./CreatePublication.vue.css?vue&type=style&index=0&id=614e7a97&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=style&index=0&id=614e7a97&lang=css"
import "./CreatePublication.vue.scss?vue&type=style&index=1&id=614e7a97&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=style&index=1&id=614e7a97&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614e7a97"],['__file',"src/Web/scripts/pages/publication/CreatePublication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "614e7a97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('614e7a97', __exports__)) {
    api.reload('614e7a97', __exports__)
  }
  
  module.hot.accept("./CreatePublication.vue.js?vue&type=template&id=614e7a97&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublication.vue?vue&type=template&id=614e7a97&scoped=true", () => {
    api.rerender('614e7a97', render)
  })

}


export default __exports__